export enum CookiesKey {
  ACCESS_TOKEN = '@access_token',
  SSO_ACCESS = '@sso-access',
  CART_ID = '@cart',
  EMITTER_ID = '@emitter',
  ORDER_CONTINUOS = '@ordercontinuos',
  AUTHORIZATION_TOKEN = '@authorization-token',
  PROFILE_ACCESS_TOKEN = '@Profile-Access-Token',
  AUTHORIZATION_TOKEN_EXPIRATION = '@authorization-token-expiration'
}
